import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { RiHome4Line, RiFlashlightLine, RiFileTextLine, RiUser3Line, RiMore2Fill } from 'react-icons/ri';

const ITEMS = [
  { to: '/dashboard',  label: 'Learn',      icon: RiHome4Line      },
  { to: '/flashcards', label: 'Flashcards', icon: RiFlashlightLine },
  { to: '/quiz',       label: 'Quiz',       icon: RiFileTextLine   },
  { to: '/profile',    label: 'Profile',    icon: RiUser3Line      },
];

const ITEM_PATHS = ITEMS.map(i => i.to);

// Phone-only bottom tab bar. Carries the four highest-traffic destinations and
// hands everything else (Kana, Kanji, Grammar, Progress, Practice Tests,
// Logout) to the "More" tab, which opens the existing drawer/sidebar.
export default function MobileBottomNav({ onOpenMore }) {
  const location = useLocation();
  const isMoreActive = !ITEM_PATHS.includes(location.pathname);

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary">
      {ITEMS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) => `mobile-bottom-nav-item${isActive ? ' active' : ''}`}
        >
          <Icon size={22} />
          <span>{label}</span>
        </NavLink>
      ))}
      <button
        type="button"
        className={`mobile-bottom-nav-item${isMoreActive ? ' active' : ''}`}
        onClick={onOpenMore}
      >
        <RiMore2Fill size={22} />
        <span>More</span>
      </button>
    </nav>
  );
}
